import { RundownSettingsPanel } from "@/components/rundown/RundownSettingsPanel";

export function SettingsRundownPage() {
  return <RundownSettingsPanel />;
}
